import React from 'react'
import { NavLink } from 'react-router-dom'
import { BodyText } from '@paypalcorp/pp-react'
import { ExternalLink } from '../common/external-link'
import constant from '../../common/constant'
import { Icon } from '@paypalcorp/ppods-react'

const MenuLink = ({
  isSubMenu = false,
  item,
  isActive,
  children,
  addFPTIHandler,
}) => {
  if (item.path.startsWith('https://')) {
    return (
      <BodyText
        as={ExternalLink}
        href={item.path}
        target={item.target || '_self'}
        className={`header-nav__link${
          isActive ? ' header-nav__link--active' : ''
        }`}
        data-dxa={
          constant.FPTI_PAGES_CATEGORIES.TOP_NAV + ',click,' + item.label
        }
        style={{ display: 'flex', gap: '8px' }}
        onClick={addFPTIHandler}
      >
        {children}
        {isSubMenu ? (
          <Icon
            name="open-browser"
            size="18"
            aria-label="open-browser"
            aria-hidden="true"
          />
        ) : null}
      </BodyText>
    )
  }
  return (
    <BodyText
      as={NavLink}
      to={item.path}
      target={'_self'}
      className={`header-nav__link${
        isActive ? ' header-nav__link--active' : ''
      }`}
      data-dxa={constant.FPTI_PAGES_CATEGORIES.TOP_NAV + ',click,' + item.label}
      onClick={addFPTIHandler}
    >
      {children}
    </BodyText>
  )
}

export default MenuLink
